// flow

export const MAX_SCRIPT_BLOCK = 50;
export const DEFAULT_VERSION = 1;
export const DEFAULT_LOCKTIME = 0;
export const DEFAULT_SEQUENCE = 0xffffffff;
export const SIGHASH_ALL = 1;
export const OP_DUP = 0x76;
export const OP_HASH160 = 0xa9;
export const HASH_SIZE = 0x14;
export const OP_EQUALVERIFY = 0x88;
export const OP_CHECKSIG = 0xac;
export const OP_RETURN = 0x6a;
